<template>
	<div v-if="te('article')" class="container-fluid h-100 w-100">
		<div class="article-container">
			<h1>{{ t(`article[${routerID}].title`) }}</h1>
			<p v-html="t(`article[${routerID}].text`)"></p>
		</div>
        <div class="article-image" :style="articleImage"></div>
	</div>
</template>

<script>
import { useI18n } from "vue-i18n";

export default {
	name: "ScreensaverArticle",
    props: {
		id: String,
	},
    setup() {
		const { t, te, tm } = useI18n();
		return { t, te, tm };
	},
    computed: {
		routerID() {
			const { t, te, tm } = useI18n();

			if (this.id != null) {
				if (te("article")) {
					for (let i = 0; i < tm("article").length; i++) {
						if (t(`article[${i}].post_id`) == this.id) {
							return i;
						}
					}
				}
			}
			return "";
		},
        articleImage() {
			const { t, te, tm } = useI18n();
			return `background-image: url('${t(`article[${this.routerID}].image`)}');`;
		},
	},
};
</script>

<style scoped>
    .article-image {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		width: 50%;
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
	}

	.article-container {
		padding-top: 230px;
		padding-left: 170px;
		padding-right: 100px;
		width: 50%;
		color: #fff;
	}

	.article-container h1 {
		font-size: 48px;
		font-weight: bold;
	}

	.article-container h2 {
		font-size: 36px;
		font-weight: bold;
	}

	.article-container h3 {
		font-size: 30px;
		font-weight: bold;
	}

	.article-container h4 {
		font-size: 25px;
	}

	.article-container h4.bold {
		font-weight: bold;
	}

	.article-container p {
		margin-top: 24px;
		font-size: 30px;
		font-weight: 400;
		line-height: 1.4em;
	}
</style>